import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './AlsoBuyingRejectionSurveyModal.scss';

const SURVEY_ANSWERS_WON_AGENT = {
    moving: 'I am moving out of the area.',
    notBuying: 'I am not buying immediately.',
    // homeLoan: 'I need help with a home loan.', TODO:: Remove UHL
    otherAgent: 'I have another buyer’s agent.',
    notHappy: 'I don’t like working with {agentName}, I need other recommendations.',
    otherReason: 'Other reason'
};

const SURVEY_ANSWERS = {
    notBuyingNewHome: 'I don’t need to buy a new home.',
    needSellingFirst: 'I need to sell my house first.',
    notBuyingRightNow: 'I am not buying a home immediately.',
    // needHomeLoanHelp: 'I need help with a home loan.', TODO:: Remove UHL
    otherReason: 'Other reason'
};

export default class AlsoBuyingRejectionSurveyModal extends Component {
    state = {
        modalState: this.modalState,
        isInvalid: false,
        rejectReason: '',
        detailedRejectReason: '',
        contentToRender: 'renderSurvey',
        phone: '',
        isUpdatingPhone: false
    };

    componentWillMount() {
        if (this.props.wonAgent) {
            SURVEY_ANSWERS_WON_AGENT.notHappy = SURVEY_ANSWERS_WON_AGENT.notHappy.replace(
                '{agentName}',
                this.props.wonAgent
            );
        }
        this.setState({phone: this.props.phone || ''});
    }

    handleInputChange = ({target: {value, type}}) => {
        if (type === 'radio') {
            this.setState({
                rejectReason: value,
                detailedRejectReason: ''
            });
        }
        if (type === 'textarea') {
            this.setState({
                detailedRejectReason: value
            });
        }
    };

    handlePhoneInput = event => {
        const phone = returnNumbersOnly(returnPhoneFormat(event.target.value));
        this.setState({phone});
    };

    handlePhoneChangeFormSubmit = event => {
        event.preventDefault();

        const $phoneInput = $(this.phoneInputRef);
        if (!$phoneInput.valid()) {
            return;
        }

        $.post('update-user-json', {
            userId: this.props.userId,
            phone: this.state.phone
        })
            .then(data => {
                checkAjax(data);
            })
            .fail(() => {
                defaultAjaxError();
            });

        this.setState({isUpdatingPhone: false});
    };

    onFormSubmit = event => {
        event.preventDefault();
        let isInvalid = !this.state.rejectReason || !this.state.detailedRejectReason;
        if (isInvalid) {
            this.setState({
                isInvalid: true
            });
            return;
        }

        const {requestId, userId, alsoBuying, wonAgent} = this.props;
        const alsoBuyRejectReason = wonAgent
            ? SURVEY_ANSWERS_WON_AGENT[this.state.rejectReason]
            : SURVEY_ANSWERS[this.state.rejectReason];
        const alsoBuyDetailedRejectReason = this.state.detailedRejectReason;
        const params = {
            requestId,
            'alsoBuyRejectReason': alsoBuyRejectReason,
            'alsoBuyDetailedRejectReason': alsoBuyDetailedRejectReason,
            'req.alsoBuying': false
        };
        $.post('update-req-thankyou-json', {...params})
            .then(data => {
                if (checkAjax(data)) {
                    this.setState({contentToRender: 'renderDisapproval'});
                }
            })
            .fail(() => {
                defaultAjaxError();
            });
    };

    renderSurvey() {
        const {requestType, wonAgent} = this.props;
        const {rejectReason, detailedRejectReason, isInvalid} = this.state;

        return (
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="title-block">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h4 className="modal-title">Please let us know why you decided not to buy a home?</h4>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="survey-block">
                            {Object.keys(wonAgent ? SURVEY_ANSWERS_WON_AGENT : SURVEY_ANSWERS).map(key => (
                                <div key={key} className="form-group">
                                    <div className="pretty p-default p-round">
                                        <input
                                            name="alsoBuyRejectReason"
                                            type="radio"
                                            value={key}
                                            onChange={e => this.handleInputChange(e)}
                                        />
                                        <div className="state p-primary-o">
                                            <label>
                                                {wonAgent ? SURVEY_ANSWERS_WON_AGENT[key] : SURVEY_ANSWERS[key]}
                                            </label>
                                        </div>
                                    </div>
                                    {rejectReason === key && [
                                        <div className="detailed-input-block">
                                            <textarea
                                                ref={r => (this[`${key}DetailedInput`] = r)}
                                                type="text"
                                                className="form-control detailed-input-txt"
                                                placeholder="Can you give us more details on that?"
                                                onKeyUp={e => this.handleInputChange(e)}
                                                data-gramm="false"
                                                data-gramm_editor="false"
                                                data-enable-grammarly="false"
                                            />
                                        </div>,
                                        !!this[`${key}DetailedInput`]?.value ? null : (
                                            <div className="survey-validation-error">This field is required</div>
                                        )
                                    ]}
                                </div>
                            ))}
                            {isInvalid && (
                                <div className="form-group">
                                    <label class="survey-validation-error" generated="true">
                                        Please select at least one option, or provide other reason.
                                    </label>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="modal-buttons">
                            <button
                                type="submit"
                                className="submit-feedback-button btn btn-md btn-default"
                                disabled={!rejectReason || !detailedRejectReason}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderDisapproval = () => {
        const {isLoading} = this.state;

        return (
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header modal-header-thank-you">
                        <div className="modal-title">
                            <div className="mt-2x-sm mb-4x text-center">
                                <img src={global.imageBaseUrl + 'proposal/cart_squircle_blue.svg'} />
                            </div>
                            Thanks for letting us know!
                        </div>
                    </div>
                    <div className="modal-body modal-body-thank-you">
                        <button type="button" className="btn outline" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                    <div className="modal-footer confirmation"></div>
                    {isLoading && (
                        <div className="loadingSpinner" style="display: block; margin: 0">
                            <img src={global.imageBaseUrl + 'spinner.gif'} />
                        </div>
                    )}
                </div>
            </div>
        );
    };

    render() {
        return (
            <form id="alsoBuyRejectForm" method="POST" action="updateSurvey-json" onSubmit={this.onFormSubmit}>
                <div className="modal nu-modal fade also-buying-reject" id="alsoBuyRejectModal" role="dialog">
                    <div className="nu-modal-content">{this[this.state.contentToRender]()}</div>
                </div>
            </form>
        );
    }
}
